import { topicItems } from '@/mocks/darkwebData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1440px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            话题标签
          </h2>
          <p className="text-foreground-600 text-sm mt-2">
            暗网社区热议话题，点击查看相关内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/70 rounded-lg p-4 md:p-5 flex items-center justify-between group hover:border-primary-300 transition-colors cursor-pointer"
            >
              <div className="flex items-center gap-3 min-w-0">
                <div
                  className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${
                    item.id <= 3
                      ? 'bg-primary-100 text-primary-600'
                      : 'bg-secondary-100 text-secondary-600'
                  }`}
                >
                  <span className="font-heading text-sm font-bold">#{item.id}</span>
                </div>
                <div className="min-w-0">
                  <h3 className="font-heading text-sm font-semibold text-foreground-950 truncate">
                    {item.name}
                  </h3>
                  <div className="flex items-center gap-2 text-xs text-foreground-600 mt-0.5">
                    <span>{item.posts} 篇内容</span>
                  </div>
                </div>
              </div>
              <div className="text-right shrink-0 ml-3">
                <div className="text-sm font-bold text-accent-500 whitespace-nowrap">
                  {item.heat}
                </div>
                <div className="flex items-center justify-end gap-1 mt-0.5">
                  {item.trend === 'up' && (
                    <span className="text-xs text-primary-500 flex items-center whitespace-nowrap">
                      <i className="ri-arrow-up-s-fill"></i> 上升
                    </span>
                  )}
                  {item.trend === 'stable' && (
                    <span className="text-xs text-foreground-500 flex items-center whitespace-nowrap">
                      <i className="ri-subtract-line"></i> 持平
                    </span>
                  )}
                  {item.trend === 'down' && (
                    <span className="text-xs text-secondary-500 flex items-center whitespace-nowrap">
                      <i className="ri-arrow-down-s-fill"></i> 下降
                    </span>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}